import { render, staticRenderFns } from "./LeilaoData.vue?vue&type=template&id=606c92f2&"
import script from "./LeilaoData.vue?vue&type=script&lang=js&"
export * from "./LeilaoData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports